import { PERMISSION_ACTIONS, PERMISSION_MODULES } from "./constants";

/**
 * Shared permission requirements for menus and routes.
 * Prefer attaching `permission` on route config; use these helpers for nav/UI.
 */
export const modulePermission = {
  view: (module) => [
    { module, action: PERMISSION_ACTIONS.VIEW },
    { module, action: PERMISSION_ACTIONS.VIEW_OWN },
  ],
  create: (module) => ({ module, action: PERMISSION_ACTIONS.CREATE }),
  edit: (module) => ({ module, action: PERMISSION_ACTIONS.EDIT }),
  delete: (module) => ({ module, action: PERMISSION_ACTIONS.DELETE }),
};

/**
 * Any inventory access: view, view_own, create, or edit.
 */
export const inventoryAccessPermission = () => [
  ...modulePermission.view(PERMISSION_MODULES.INVENTORY),
  modulePermission.create(PERMISSION_MODULES.INVENTORY),
  modulePermission.edit(PERMISSION_MODULES.INVENTORY),
];

export const ROUTE_MODULE = {
  ACCOUNT: PERMISSION_MODULES.ACCOUNT,
  CALENDAR: PERMISSION_MODULES.CALENDAR,
  DEFECTS: PERMISSION_MODULES.DEFECTS,
  EVENTS: PERMISSION_MODULES.EVENTS,
  INVENTORY: PERMISSION_MODULES.INVENTORY,
  MESSAGES: PERMISSION_MODULES.MESSAGES,
  MOBILE_UNITS: PERMISSION_MODULES.MOBILE_UNITS,
  PATIENTS: PERMISSION_MODULES.PATIENTS,
  REPORTS: PERMISSION_MODULES.REPORTS,
  SETTINGS: PERMISSION_MODULES.SETTINGS,
  STAFFING: PERMISSION_MODULES.STAFFING,
  TIMESHEET: PERMISSION_MODULES.TIMESHEET,
  USERS: PERMISSION_MODULES.USERS,
  WORK_ORDERS: PERMISSION_MODULES.WORK_ORDERS,
};
